import React from 'react';
import { Tooltip } from '@gerdau/hefesto/Tooltip';
import { Icon } from '@gerdau/hefesto';

interface TooltipDetailProps {
  titleTooltip?: string;
  placement?: 'bottomLeft' | 'topLeft';
}

export const TooltipDetail = ({
  titleTooltip,
  placement = 'bottomLeft'
}: TooltipDetailProps) => {
  if (!titleTooltip) {
    return null;
  }
  return (
    <Tooltip {...{ title: titleTooltip, placement }}>
      <div className="tooltipIconContainer">
        <Icon option="Info" variant="info" size="xs" />
      </div>
    </Tooltip>
  );
};
